<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 13:48:05
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-27 15:55:43
 * @Description: 国内外大型矿业公司-数据管理
 * @FilePath: \web\src\components\DataManager\MiningCompany\index.vue
-->
<template>
  <div class="mining-company-main">
    <div class="search-container">

      <div class="search">
        <!-- S 排名 -->
        <div class="search-item">
          <div class="search-item-text">排名：</div>
          <a-input class="user-name-input" v-model:value="requestParams.count" />
        </div>
        <!-- E 排名 -->
        <div class="btn-wrapper">
          <div class="reset-btn btn-item" @click="resetSearch">重置</div>
          <div class="search-btn btn-item" @click="submitSearch()">查询</div>
        </div>
      </div>

      <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
        <div class="crud-item crud-item-abled" @click="getScreenData">
          大屏展示
        </div>
      </div>
    </div>

    <a-table rowKey="id" class="management-table" :dataSource="dataPages" :loading="dataPagesLoading" :columns="columns"
      @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>

      <template v-for="col in ['ownerName', 'name', 'nameEn', 'num', 'count',]" #[col]="{ text, record }" :key="col">
        <template v-if="!record.isEdit">
          <span>{{ text }}</span>
        </template>
        <template v-else>
          <a-input v-model:value="record[col]" />
        </template>
      </template>

      <template #action="{ record }">
        <section class="action-icons">
          <i v-for="(item, index) in tableOperationList" :key="index" v-bind="item.option" @click="item.click(record)"
            :style="{ display: ((item.option.title === '保存' || item.option.title === '取消') && !record.isEdit || item.option.title === '编辑' && record.isEdit) ? 'none' : '' }">
          </i>
          <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
            <div class="crud-item" :class="record.shows !== '1' ? 'crud-item-abled' : 'crud-item-disabled'"
              @click="beforeAddScreen(record)">
              大屏展示
            </div>
          </div>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <section v-if="confirmModalConf.isData">
          <ScreenData />
        </section>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, } from 'vue';
import { useStore, } from 'vuex';
import { message, } from 'ant-design-vue';
import Modal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import { getCompanyPageApi, companyUpdateApi, } from '@/api/bigScreen/miningCompany';
import { GET_MINING_COMPANY_PAGE, } from '@/store/modules/actions/screenDataManager';
import { tableConfig, } from './tableConfig.js';
import ScreenData from './screenData.vue';

const columns = tableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const miningCompanyState = computed(() => state.miningCompany);
const { requestParams, dataPages, totalCount, dataPagesLoading, orenodeResultVisible, activeKey, } = toRefs(
  miningCompanyState.value
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'miningCompany'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'miningCompany'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id

const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['8', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  callback: null,
  isData: false,
  width: '5.4rem',
  notFooter: false, // 是否显示底部内容
});

// 新增编辑弹窗 公用
const modalOption = reactive({
  visible: false,
  loading: false,
  datalist: {},
  modalType: 'default',
});
/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_MINING_COMPANY_PAGE);
};

// 添加至大屏数据展示
const addScreen = (record) => {
  record.shows = '1';
  companyUpdateApi(record).then(res => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
// 添加至大屏数据展示前
const beforeAddScreen = (record) => {
  confirmModalConf.title = '确认添加数据至大屏展示？';
  confirmModalConf.callback = () => addScreen(record);
  confirmModalConf.visible = true;
};
// 获取大屏展示数据
const getScreenData = () => {
  confirmModalConf.title = '大屏展示数据';
  confirmModalConf.isData = true;
  confirmModalConf.visible = true;
  confirmModalConf.notFooter = true;
  confirmModalConf.width = '8rem';
};

/**
 * @description 检索查询事件
 */
const submitSearch = () => {

  commit(null, 'setRequestParams', { page: 1, size: 10, });
  dispatch(null, GET_MINING_COMPANY_PAGE);
};

/**
 * @description 检索重置事件
 */
const resetSearch = () => {
  commit(null, 'clear');
  submitSearch();
};


/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};

// 取消数据修改
const cancelRecord = (record) => {
  for (let i in record.old) {
    record[i] = record.old[i];
  }
  record.isEdit = false;
};
// 保存数据修改
const saveRecord = (record, index) => {
  companyUpdateApi(record).then(res => {
    record.isEdit = false;
    searchHandle();
  });
};

/**
 * @description 编辑
 */
const editRecord = (record) => {
  record['old'] = JSON.parse(JSON.stringify(record));
  record.isEdit = true;
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  if (confirmModalConf.isData) {
    searchHandle();
  }
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  confirmModalConf.isData = false;
  confirmModalConf.notFooter = false;
  confirmModalConf.width = '5.4rem';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};


const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1, 2,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-baocun',
      title: '保存',
    },
    click: saveRecord,
    operation: [1,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-weibiaoti522',
      title: '取消',
    },
    click: cancelRecord,
    operation: [1,],
  },
];

onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  tableOperationList.value = tableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  searchHandle();
});
</script>

<style lang="scss">
.mining-company-main {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: .1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .search {
      display: flex;

      .search-item {
        width: 2.2rem;
        height: 0.34rem;
        margin-right: 0.05rem;
        display: flex;

        .search-item-text {
          color: #fff;
          width: 1.1rem;
          text-align: right;
          height: 0.34rem;
          line-height: 0.34rem;
        }
      }

      /* 重置、查询操作 */
      .btn-wrapper {
        height: 0.32rem;
        line-height: 0.32rem;
        margin-left: 0.2rem;
        color: #ffffff;
        display: flex;
        padding: 0;

        .btn-item {
          width: 0.9rem;
          text-align: center;
          cursor: pointer;

          &:active {
            opacity: 0.8;
          }
        }

        .reset-btn {
          // background-color: #535962;
          background-image: url(~@/static/images/dataManagement/reset_btn.png);
          background-size: 100% 100%;
        }

        .search-btn {
          margin-left: 0.05rem;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/submit_btn.png);
          background-size: 100% 100%;
        }
      }

      /* 输入框 */
      .ant-input {
        color: white;
        background-color: rgba(91, 76, 39, 0.4);
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
      }

      .ant-input-suffix {
        width: 0.12rem;
        height: 0.12rem;
        margin-top: .02rem;
      }

      /** 下拉框 */
      .ant-select {
        width: 100%;
        height: 100%;

        .ant-select-selector {
          height: 100%;
        }

        .ant-select-arrow {
          color: #fff;
        }

        .ant-select-selection-item {
          line-height: .34rem;
        }

        // 背景
        &:not(.ant-select-customize-input) .ant-select-selector {
          background-color: rgba(91, 76, 39, 0.4);
          border: none;
          color: #fff;
        }

        /* 描述 */
        .ant-select-selection-placeholder {
          line-height: .34rem;
          color: #fff;
        }
      }
    }

    /* 增删改导按钮 */
    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.7rem;
        line-height: .25rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }


  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;
          padding: 0 0.1rem;
          margin-top: 0.05rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.7rem;
            line-height: .25rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
